import { css } from '@emotion/react';

export const tableWrapperStyle = css`
  overflow: auto;

  @container (max-height: 560px) {
    min-height: 350px;
  }
`;
